import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { SET_BLACK_OVERLAY } from "../../redux/actions/types";
import { Dialog } from "@headlessui/react";
import { editPricingBanner } from "../../redux/actions/userActivity";
import { IKImage } from "imagekitio-react";
const LearnDrawer = ({ deviceInfo }) => {
  console.log("inside drawrr", deviceInfo);
  const isDarkOverlay = useSelector((store) => store?.appTheme?.blackOverlay);
  const dispatch = useDispatch();
  if (!deviceInfo) {
    return null; // Or any placeholder content you prefer
  }
  function getBrowserlogo(browser) {
    if (browser === "Unknown") {
      return "/img/browser/Default.png";
    }
    return `/img/browser/${browser}.svg`;
  }

  return (
    <Dialog
      open={
        isDarkOverlay?.showModal == true && isDarkOverlay?.is_closed == false
      }
      onClose={() => null}
      // onClose={() =>
      //     // setDiscountModal(prev => ({ ...prev, open: false, data: null }))
      // }
      as="div"
      style={{ zIndex: "9999999999" }}
      className="fixed inset-0 z-10 flex flex-col items-center justify-center overflow-y-auto md:mt-20 md:justify-start"
    >
      <Dialog.Overlay className="fixed inset-0 z-10 bg-black opacity-50" />
      <Dialog.Title />
      <Dialog.Description />
      {/* <div className="absolute z-[99999999] inset-0 bg-black bg-opacity-50" ></div> */}
      <div
        className={`show-animation fixed bottom-0 z-[999999999] flex h-[230px] w-full flex-col items-center justify-start    rounded-t-2xl bg-white py-6 px-3 text-white`}
      >
        <div className="w-full text-center text-[18px] font-semibold text-black">
          Continue Learning On...
        </div>
        <div className="mt-6 flex w-full flex-row items-center justify-between">
          <div className="flex items-center justify-center ">
            <div className="mr-4 flex h-[52px] w-[52px] items-center justify-center rounded-xl border-2 border-[#D3D3D3]">
              <img
                src="https://img.learntube.ai/public-assets/AI_Syllabus_generator/image_11.png?updatedAt=1685175860985"
                width={32}
                height={32}
                alt="learntube logo"
              />
            </div>
            <div className="flex flex-col items-start justify-center">
              <div className="text-[16px] font-semibold text-black">
                LearnTube App
              </div>
              <div className="flex gap-2 text-[11px] font-medium text-[#1CA571]">
                Get
                <img
                  urlEndpoint="https://img.learntube.ai/public-assets/"
                  src={`https://img.learntube.ai/public-assets/Ai%20notes/Group%2020631.svg?updatedAt=1716999520358`}
                  className="h-[12px] w-[12px]"
                  transformation={[
                    {
                      height: "60",
                      width: "60",
                    },
                  ]}
                />
                +100 On Your First Use
              </div>
            </div>
          </div>
          <button
            className="w-[106px] rounded-3xl bg-[#1CA571]  py-2 text-[16px] font-semibold text-white"
            onClick={() =>
              window.open(
                "https://learntube.page.link/web_landing",
                "_blank",
                "noopener,noreferrer",
              )
            }
          >
            Open
          </button>
        </div>

        <div className="mt-4 flex w-full flex-row items-center justify-between">
          <div className="flex items-center justify-center ">
            <div className="mr-4 flex h-[52px] w-[52px] items-center justify-center rounded-xl border-2 border-[#D3D3D3]">
              <img
                src={getBrowserlogo(deviceInfo?.browser_name)}
                width={32}
                height={32}
                alt="browser logo"
              />
            </div>
            <div className="text-[16px] font-semibold text-black">
              {deviceInfo?.browser_name === "Unknown"
                ? "Browser"
                : deviceInfo?.browser_name}
            </div>
          </div>
          <button
            className="w-[106px] rounded-3xl bg-[#E3E8EC] py-2  text-[16px] font-semibold text-black"
            onClick={(e) => {
              dispatch(editPricingBanner(false));
              dispatch({
                type: SET_BLACK_OVERLAY,
                payload: {
                  ...isDarkOverlay,
                  is_closed: true,
                  showModal: false,
                  is_expired: true,
                  expire_time: new Date().getTime() + 24 * 60 * 60 * 1000,
                },
              });
            }}
          >
            Continue
          </button>
        </div>
      </div>
    </Dialog>
  );
};

export default LearnDrawer;
